module.exports = __webpack_public_path__ + "static/media/CenturyGothic.3f035425.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/CenturyGothic.ttf
// module id = 11
// module chunks = 0